const BecomeARooter = () => {
  return <div>Become a rooter page</div>
}

export { BecomeARooter }
